module.exports = __webpack_public_path__ + "static/media/view2.8f59716a.jpg";